module.exports = __webpack_public_path__ + "static/media/IconTemplates_-94.db958ae8.svg";